import { render } from "./modal-edit-mobile-page.html?vue&type=template&id=29580d34&scoped=true&ts=true"
import script from "./modal-edit-mobile-page.vue?vue&type=script&lang=ts"
export * from "./modal-edit-mobile-page.vue?vue&type=script&lang=ts"

import "./modal-edit-mobile-page.scss?vue&type=style&index=0&id=29580d34&scoped=true&lang=scss"

import exportComponent from "/builds/customer/line/line-web-loyalty/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-29580d34"]])

export default __exports__